import { createReducer, on } from '@ngrx/store';
import { CustomProductListState } from '../custom-product-list.state';
import { CustomProductActions } from '../action';

export const initialState: CustomProductListState = {
  products: [],
};

export const customProductListReducer = createReducer(
  initialState,
  on(
    CustomProductActions.loadProductsSuccess,
    (state, { products }) => ({
      ...state,
      products
    })
  ),
  on(
    CustomProductActions.loadPricesBatch,
    (state, { productCodes }) => ({
      ...state,
      products: state.products.map((p) =>
        productCodes.includes(p.code)
          ? { ...p, priceLoading: true, priceError: false }
          : p
      ),
    })
  ),
  on(
    CustomProductActions.loadPricesBatchSuccess,
    (state, { productCode, discountPriceData, quotationFlag, obsoleteFlag }) => ({
      ...state,
      products: state.products.map((p) =>
        p.code === productCode
          ? {
            ...p,
            priceLoading: false,
            priceError: false,
            discountPriceData: discountPriceData,
            quotationFlag: quotationFlag,
            obsoleteFlag: obsoleteFlag,
          }
          : p
      ),
    })
  ),
  on(
    CustomProductActions.loadPricesBatchFailure,
    (state, { error, productCode }) => ({
      ...state,
      products: state.products.map((p) =>
        p.code === productCode
          ? { ...p, priceLoading: false, priceError: true, error: error }
          : p
      ),
    })
  )
);